module.exports = __webpack_public_path__ + "img/archesthumb.cf3f70d1.jpg";